<ng-container *ngIf="formData && languageSelectItems && supportedCategories">
  <div mat-dialog-content class="self-service-form-container">
    <mat-stepper orientation="vertical" class="self-service-stepper" #stepper linear animationDuration="750">
      <!--  Step 1: select language of generated document -->
      <mat-step [stepControl]="languageForm" [errorMessage]="formData.languageStepError | formData">
        <ng-template matStepLabel>
          <b>{{ formData.languageStepTitle | formData }}</b>
        </ng-template>
        <ng-template matStepContent>
          <app-language-step
            [stepForm]="languageForm"
            [formData]="formData"
            [languageSelectItems]="languageSelectItems"
          ></app-language-step>
        </ng-template>
      </mat-step>

      <!-- Step 2: select document contents -->
      <mat-step [stepControl]="contentForm" [errorMessage]="formData.contentStepError | formData">
        <ng-template matStepLabel>
          <b>{{ formData.contentStepTitle | formData }}</b>
        </ng-template>
        <ng-template matStepContent>
          <app-content-step
            [stepForm]="contentForm"
            [formData]="formData"
            [infoPageSelectItems]="infoPageSelectItems"
            [documentTypeSelectitems]="documentTypeSelectItems"
            [brand]="brand"
          ></app-content-step>
        </ng-template>
      </mat-step>

      <!-- Step 3: preselection -->
      <mat-step>
        <ng-template matStepLabel>
          <b>{{ formData.preSelectStepTitle | formData }}</b>
        </ng-template>
        <ng-template matStepContent>
          <app-preselection-step
            [formData]="formData"
            [filterValues]="filterValues"
            [initialValues]="selectedFilters"
            (selectionChanged)="preselectionChanged($event)"
          ></app-preselection-step>
        </ng-template>
      </mat-step>

      <!-- Step 4: final selection and generation-->
      <mat-step>
        <ng-template matStepLabel>
          <b>{{ formData.generateStepTitle }}</b>
        </ng-template>
        <ng-template matStepContent>
          <app-generation-step
            [formData]="formData"
            [language]="languageControl.value!.key"
            [infoPage]="infoPageControl.value?.key || null"
            [documentType]="contentControl.value?.key || 'full'"
            [brand]="brandControl.value?.key || 'dec'"
            [supportedCategories]="supportedCategories"
            [filterValues]="selectedFilters"
          ></app-generation-step>
        </ng-template>
      </mat-step>
    </mat-stepper>
  </div>
</ng-container>
